<template>
    <div class="countdown" v-if="timeLeft > 0">
        <img
            src="@/assets/img/payment-timer-icon.svg"
            alt="icone de relogio"
            class="countdown__icon"
            tabindex="-1"
        />
        <span class="countdown__text">
            <span v-text="$ml.get('countdownFinishPayment')" />
            <strong class="countdown__time">{{ formattedTime }}</strong>
        </span>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Countdown',
  props: {
    seconds: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('countdown', ['timeLeft']),
    formattedTime() {
      const min = Math.floor(this.timeLeft / 60)
        .toString()
        .padStart(2, '0');
      const sec = (this.timeLeft % 60)
        .toString()
        .padStart(2, '0');
      return `${min}:${sec}`;
    }
  },
  methods: {
    ...mapActions('countdown', ['startCountdown', 'stopCountdown']),
  },
  mounted() {
    if (this.timeLeft === null) {
      this.startCountdown(this.seconds);
    }
  },

  watch: {
    timeLeft(newVal) {
      if (newVal === 0) {
        this.$emit('finished');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.countdown {
	display: flex;
	justify-content: center;
	align-items: center;
	background: #EFF1F3;
	border-radius: 12px;
	padding: 12px 0;
	margin-bottom: 24px;

	&__text {
		font-size: 14px;
		font-weight: 500;
		color: #2F363E;
		margin-left: 8px;
	}

	&__time {
		font-weight: 700;
		margin-left: 2px;
		color: #2F363E;
	}
}
</style>
